import { useAuth } from "../stores/auth";

// Whether the current company licenses a given EEX feature (e.g. 'eua', 'physical',
// 'currency:GBP'). Defensive: the eexBilling summary may be absent on a stale/old
// /auth/me payload, so absent reads as "not licensed" rather than throwing. No UI
// surface consumes this yet (Phase 1) — the D2a audit wires it into the views.
export function useEexFeature(featureKey: string): boolean {
  return useAuth((s) => s.user?.eexBilling?.features?.includes(featureKey) ?? false);
}

// The full billing summary for the current company, or null when absent.
export function useEexBilling() {
  return useAuth((s) => s.user?.eexBilling ?? null);
}
